import { render, staticRenderFns } from "./viewGap.vue?vue&type=template&id=397ac58c"
import script from "./viewGap.vue?vue&type=script&lang=js"
export * from "./viewGap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports